<div class="no-data-indicator">
  <h2 class="no-data-title">{{ noDataTitle }}</h2>
  <h4 class="no-data-sub-title">{{ noDataSubTitle }}</h4>
</div>
